const AuthData = {
    getAuthData: function() {
        return {
            clientId: process.env.REACT_APP_CLIENTID,
            appFunctionUrl: process.env.REACT_APP_APPFUNCTIONURL,
            azureFunctionKey: process.env.REACT_APP_AZUREFUNCTIONKEY
        }
    }
};

export default AuthData;